import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IGetGroupInvitesParams,
  IGroupInvite,
  IPostGroupInviteParams,
  IPutGroupInviteParams,
} from '@network/models/group-invite.model'

export class GroupInvitesApi {
  constructor(private axios: AxiosService) {}

  getGroupInvites = async (params?: IGetGroupInvitesParams) => {
    const response = await this.axios.get<IPayload<IGroupInvite[]>>(
      Endpoints.getGroupInvites,
      params,
    )
    return response
  }

  getGroupInvite = async (id: number, params?: IGetGroupInvitesParams) => {
    const response = await this.axios.get<IPayload<IGroupInvite>>(
      Endpoints.getGroupInvite(id),
      params,
    )
    return response
  }

  postGroupInvite = async (params?: IPostGroupInviteParams) => {
    const response = await this.axios.post<IPayload<IGroupInvite>>(
      Endpoints.postGroupInvite,
      params,
    )
    return response
  }

  putGroupInvite = async (id: number, params?: IPutGroupInviteParams) => {
    const response = await this.axios.put<IPayload<IGroupInvite>>(
      Endpoints.putGroupInvite(id),
      params,
    )
    return response
  }
}
